import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Nav } from 'react-bootstrap';
import '../../userLayout.scss';

import { ReactComponent as Logo } from '../../../../assets/images/logo.svg';

const FooterDashboard = () => {
  return (
    <footer className="footer-top">
      <div className='user-container'>
        {/* <span>&copy; {new Date().getFullYear()} Map My App</span>
         */}
        <Row className='align-items-center'>
          <div className='footer-logo col-md-2'>
              <Logo />
          </div>
          <div className='footer-menu main-menu col-md-6'>
            <Nav>
              <Nav.Link as={NavLink}>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Features
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Why us
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Testimonial
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  {/* Blog */}
                  Contact Us
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Price
                </Nav.Link>
            </Nav>
          </div>
          <div className='footer-menu col-md-4'>
            <Nav>
              <Nav.Link as={NavLink}>
                  Terms & Conditions
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Privacy policy
                </Nav.Link>
            </Nav>
          </div>
        </Row>
      </div>
    </footer>
  );
};

export default FooterDashboard;
